import { defineStore } from 'pinia'
import * as Sentry from '@sentry/vue'
import { sdk } from '@/components/registration.sdk'
import { useCountriesStore } from '@/stores/countries'

export const useInitStore = defineStore('init', {
  state: () => ({
    /**
     * Site info settings
     * @type {{
     *    brand_name: string,
     *    email_info: string,
     *    email_support: string,
     *    logo_file: string,
     *    css_url: string,
     *    registration_logo: string,
     *    registration_css_url: string,
     *    js_url: string,
     *    favicon_url: string
     * }}
     */
    settings: {},

    /**
     * Is registration available
     */
    available: true,

    genders: [],
    companyFileTypes: [],
    addressTypes: [],
    memberTypes: [],
    memberFileTypes: [],
    kycFoundSources: [],
    kycBusinessSectors: [],
    kycMoneyTurnover: [],
    kycPaymentsCount: [],
    counterpartyType: [],
    counterpartyFileType: [],
    addressConfirmationType: [],
    memberSourceFundsFileType: [],
    companyIndividualAddressConfirmationFileType: [],
    companyIndividualResidencePermitFileType: [],
    companyIndividualIDDocumentFileType: [],

    /**
     * @type {{terms_and_conditions: string}}
     */
    links: {},
    fileConditions: {
      extensions: ['pdf', 'jpg', 'jpeg', 'png'],
    },
  }),
  actions: {
    async initApp() {
      try {
        const [countries, registration, siteInfo, fileConditions] =
          await Promise.all([
            sdk.countries.list(),
            sdk.registration.list(),
            sdk.site.info(),
            sdk.registration.files.conditions(),
          ])

        // Pinia returns the same store instance when the app pinia is active
        const countriesStore = useCountriesStore()
        countriesStore.setCountriesList(countries.data)

        const response = registration.data

        this.genders = response.memberGender
        this.memberTypes = response.memberType
        this.companyFileTypes = response.companyFileType
        this.addressTypes = response.addressType
        this.memberFileTypes = response.memberFileType
        this.kycFoundSources = response.kycFoundSources
        this.kycBusinessSectors = response.kycBusinessSelector
        this.kycMoneyTurnover = response.kycMoneyTurnover
        this.kycPaymentsCount = response.kycPaymentsCount
        this.counterpartyType = response.counterpartyType
        this.counterpartyFileType = response.counterpartyFileType
        this.addressConfirmationType =
          response.memberAddressConfirmationFileType
        this.memberSourceFundsFileType = response.memberSourceFundsFileType
        this.links = response.links
        this.companyIndividualAddressConfirmationFileType =
          response.companyIndividualAddressConfirmationFileType
        this.companyIndividualResidencePermitFileType =
          response.companyIndividualResidencePermitFileType
        this.companyIndividualIDDocumentFileType =
          response.companyIndividualIDDocumentFileType

        const dataInfo = siteInfo.data
        this.settings = dataInfo.settings

        if (dataInfo.available) {
          this.available = dataInfo.available.reg
        }

        this.fileConditions = fileConditions.data
      } catch (error) {
        console.error('Init app failed:', error)
        Sentry.captureException(error)
        throw error
      }
    },
  },
})
